/* Store — product-page rows built from Shopify's predictive search:
   "You may also like" (same name start) and "More from <brand>" (same vendor).
   Rows load one after another so the same product is never shown twice. */
(function () {
  if (window.btfSimilarInit || !window.fetch) return;
  window.btfSimilarInit = true;

  var seen = {};

  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fetchProducts(root, q) {
    var fields = root.dataset.fields || 'title';
    var url = root.dataset.url + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=' + encodeURIComponent(fields);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        return (data && data.resources && data.resources.results && data.resources.results.products) || [];
      })
      .catch(function () { return []; });
  }

  function usable(list, root) {
    var vendor = (root.dataset.vendor || '').toLowerCase();
    return list.filter(function (p) {
      if (!p || seen[p.handle]) return false;
      if (vendor && p.vendor && String(p.vendor).toLowerCase() !== vendor) return false;
      return true;
    });
  }

  function render(root, items) {
    var limit = parseInt(root.dataset.limit, 10) || 8;
    var symbol = root.dataset.currency || '$';
    var grid = root.querySelector('[data-btf-similar-grid]');
    items = items.slice(0, limit);
    if (items.length < 2 || !grid) return;
    items.forEach(function (p) { seen[p.handle] = 1; });
    grid.innerHTML = items.map(function (p) {
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      var price = p.price ? symbol + p.price : '';
      return '<li><a class="btf-similar__card" href="' + esc(p.url) + '">' +
        '<span class="btf-similar__img">' + (img ? '<img src="' + esc(sized(img, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') + '</span>' +
        '<span class="btf-similar__name">' + esc(p.title) + '</span>' +
        (price ? '<span class="btf-similar__price">' + esc(price) + '</span>' : '') +
        '</a></li>';
    }).join('');
    root.hidden = false;
  }

  function fetchComplementary(root) {
    if (!root.dataset.recsUrl || !root.dataset.productId) return Promise.resolve([]);
    var url = root.dataset.recsUrl + '.json?product_id=' + root.dataset.productId + '&intent=complementary&limit=8';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        return ((data && data.products) || []).map(function (p) {
          return {
            handle: p.handle,
            title: p.title,
            url: p.url,
            image: p.featured_image || (p.images && p.images[0]) || '',
            price: typeof p.price === 'number' ? (p.price / 100).toFixed(2) : p.price
          };
        });
      })
      .catch(function () { return []; });
  }

  function interleave(lists) {
    var out = [], i = 0, more = true;
    while (more) {
      more = false;
      lists.forEach(function (l) { if (l[i]) { out.push(l[i]); more = true; } });
      i++;
    }
    return out;
  }

  function loadRoutine(root) {
    var terms = root.dataset.queries.split(';').filter(Boolean);
    return fetchComplementary(root).then(function (picked) {
      return Promise.all(terms.map(function (t) { return fetchProducts(root, t); })).then(function (lists) {
        var all = usable(picked, root).concat(interleave(lists.map(function (l) { return usable(l, root); })));
        var dedupe = {};
        return all.filter(function (p) { if (!p.handle || dedupe[p.handle]) return false; dedupe[p.handle] = 1; return true; });
      });
    }).then(function (items) { render(root, items); });
  }

  function load(root) {
    if (root.dataset.queries) return loadRoutine(root);
    return fetchProducts(root, root.dataset.query).then(function (list) {
      var items = usable(list, root);
      var fb = root.dataset.fallback;
      if (items.length >= 2 || !fb || fb === root.dataset.query) return items;
      return fetchProducts(root, fb).then(function (more) {
        var all = items.concat(usable(more, root)), dedupe = {};
        return all.filter(function (p) { if (dedupe[p.handle]) return false; dedupe[p.handle] = 1; return true; });
      });
    }).then(function (items) { render(root, items); });
  }

  function start() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-btf-similar]'));
    rows.forEach(function (r) { if (r.dataset.exclude) seen[r.dataset.exclude] = 1; });
    if (rows[0] && rows[0].dataset.exclude) {
      try {
        var h = rows[0].dataset.exclude;
        var list = JSON.parse(localStorage.getItem('btf_recent') || '[]').filter(function (x) { return x !== h; });
        list.unshift(h);
        localStorage.setItem('btf_recent', JSON.stringify(list.slice(0, 12)));
      } catch (e) {}
    }
    rows.reduce(function (chain, root) {
      return chain.then(function () { return load(root); });
    }, Promise.resolve());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
